var _classCallCheck = require("/Users/sunnypoon/Documents/workspace/evvr-editor/composer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sunnypoon/Documents/workspace/evvr-editor/composer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/sunnypoon/Documents/workspace/evvr-editor/composer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/sunnypoon/Documents/workspace/evvr-editor/composer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/sunnypoon/Documents/workspace/evvr-editor/composer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

/*!
 * banner:
 * react-switch-case: 1.5.0
 * Aleksandrov Sergey <gooddev.sergey@gmail.com> (https://github.com/AlexSergey/react-switch-case)
 * Little switch-case React component to render nested components.
 * MIT
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.Switch = t(require("react")) : e.Switch = t(e.React);
}(this, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "Case", function () {
      return u;
    }), n.d(t, "Default", function () {
      return i;
    });
    var r = n(1);

    function o(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var u =
    /*#__PURE__*/
    function (_r$Component) {
      _inherits(u, _r$Component);

      function u() {
        _classCallCheck(this, u);

        return _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments));
      }

      _createClass(u, [{
        key: "render",
        value: function render() {
          return this.props.children;
        }
      }]);

      return u;
    }(r.Component);

    o(u, "componentName", "case");

    var i =
    /*#__PURE__*/
    function (_r$Component2) {
      _inherits(i, _r$Component2);

      function i() {
        _classCallCheck(this, i);

        return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
      }

      _createClass(i, [{
        key: "render",
        value: function render() {
          return this.props.children;
        }
      }]);

      return i;
    }(r.Component);

    o(i, "componentName", "default"), t.default =
    /*#__PURE__*/
    function (_r$Component3) {
      _inherits(_class, _r$Component3);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "getChildren",
        value: function getChildren() {
          var _this = this;

          var e = [],
              t = [];
          return r.Children.forEach(this.props.children, function (n) {
            switch (n.type.componentName) {
              case "case":
                "function" == typeof _this.props.condition ? _this.props.condition(n.props.value) && e.push(n) : _this.props.condition === n.props.value && e.push(n);
                break;

              case "default":
                t.push(n);
            }
          }), e.length > 0 ? e : t;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.getChildren();
          return 0 === e.length ? null : e;
        }
      }]);

      return _class;
    }(r.Component);
  }, function (t, n) {
    t.exports = e;
  }]);
});